import { render, staticRenderFns } from "./user_select_criteria.vue?vue&type=template&id=5fb66f9e&scoped=true"
import script from "./user_select_criteria.vue?vue&type=script&lang=ts&setup=true"
export * from "./user_select_criteria.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./user_select_criteria.vue?vue&type=style&index=0&id=5fb66f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb66f9e",
  null
  
)

export default component.exports